import { createAsyncAction } from 'typesafe-actions';
import { LinkResponse } from './products/types';
import { BellaThunkAction } from './types';

export const findLinkByType = (links: LinkResponse[], relQuery: string): string => {
    if (!links) {
        return '';
    }
    const linkObject = links.find((link: LinkResponse) => link.rel === relQuery);
    return linkObject ? linkObject.href : '';
};

// todo: remove the url parsing once we have proper response in the api.
export default (links: LinkResponse[], relQuery: string): string => {
    const linkObject = findLinkByType(links, relQuery);
    return linkObject ? new URL(linkObject).pathname : '';
};

export const createLocalActionType = (prefix: string) => (type: string) => `${prefix}/${type}`;

export const createFetchActions = <FeetchPayload, SuccessPayload, FailedPayload>(prefix: string) =>
    createAsyncAction(
        createLocalActionType(prefix)('FETCH_START'),
        createLocalActionType(prefix)('FETCH_SUCCESS'),
        createLocalActionType(prefix)('FETCH_FAILED')
    )<FeetchPayload, SuccessPayload, FailedPayload>();

type CombineThunksSignature = <T>(
    ...args: Array<BellaThunkAction<Promise<void>, T>>
) => BellaThunkAction<Promise<void>, T>;

export const combineThunks: CombineThunksSignature = (...args) => async (dispatch, getState, deps) => {
    await Promise.all(args.map(thunk => thunk(dispatch, getState, deps)));
};

export const extractImageFromUrl = (image: string) =>
    (image.split(/\//).pop() || '').split(/\.(jpg|png|jpeg|gif|webp)/).shift() || '';

export const splitAsyncAction = <T extends Pick<T, 'success' | 'request' | 'failure'>>({
    request,
    success,
    failure,
}: T) => [request, success, failure];
